module.exports = __webpack_public_path__ + "static/media/jackpot.999ac561.png";